import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Lenis from "@studio-freight/lenis";
import LandingALAB from "./screens/LandingPage/LandingAlab";

export default function App() {
  useEffect(() => {
    AOS.init({});
  });

  const lenis = new Lenis({
    duration: 3,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  return (
    <BrowserRouter>
      <>
        <Routes>
          <Route path="/" element={<LandingALAB />} />
          <Route path="/home" element={<LandingALAB />} />
          <Route path="/landingALAB" element={<LandingALAB />} />
        </Routes>
      </>
    </BrowserRouter>
  );
}
